// extracted by mini-css-extract-plugin
module.exports =  {"title":"ymoP1F","totalLine":"S5Pf9z","multipleTotalsRoot":"kARi0n"};